import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import type {FEEDBACK_CONFIG_RESPONSE} from 'src/types/crm';

import RichTextEditor from 'src/components/lib/rich-text-editor';

import {convertHTMLToDraftJS} from 'src/utils/crm-new/common';
import {
  ButtonTabs,
  ButtonTab,
} from '@spaced-out/ui-design-system/lib/components/ButtonTabs';
import {TruncatedTextWithTooltip} from '@spaced-out/ui-design-system/lib/components/TruncatedTextWithTooltip';

import {
  SubTitleSmall,
  BodySmall,
} from '@spaced-out/ui-design-system/lib/components/Text';

import css from './evaluation-recommendation-edit.css';


const EvaluationRecommendationEdit = ({
  reviewStatus,
  comment,
  feedbackConfiguration,
  onReviewStatusChange,
  onCommentChange,
  stepType,
}: {
  reviewStatus: string;
  comment: string;
  feedbackConfiguration: FEEDBACK_CONFIG_RESPONSE;
  onReviewStatusChange: (value: string) => void;
  onCommentChange: (value: string) => void;
  stepType: string;
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const feedbackNames =
    feedbackConfiguration && feedbackConfiguration.feedbackNames
      ? feedbackConfiguration.feedbackNames.split(',')
      : [];

  if (!feedbackConfiguration) {
    return null;
  }

  return (
    <>
      <div className={css.column}>
        <div className={css.divider}></div>
        <SubTitleSmall>
          {t('Overall_Recommendation', 'Overall Recommendation')}{' '}
          <span className={css.required}>*</span>
        </SubTitleSmall>
        <div className={css.column}>
          <BodySmall color="tertiary">
            {stepType === 'FEEDBACK'
              ? feedbackConfiguration.reviewTitle
              : feedbackConfiguration.feedbackTitle}
          </BodySmall>
          <ButtonTabs
            onButtonTabSelect={(value) => onReviewStatusChange(value)}
            selectedButtonTabId={reviewStatus}
            isFluid={true}
          >
            {feedbackNames.map((item) => (
              <ButtonTab id={item.toLowerCase().trim()}>
                <TruncatedTextWithTooltip
                  tooltip={{
                    bodyMaxLines: 3,
                    elevation: 'modal',
                  }}
                >
                  {item}
                </TruncatedTextWithTooltip>
              </ButtonTab>
            ))}
          </ButtonTabs>
        </div>
      </div>

      {feedbackConfiguration.hasNote ? (
        <RichTextEditor
          label={`${t('Overall_Comment', 'Overall Comment')}`}
          placeholder={
            feedbackConfiguration.minFeedbackWords
              ? t(
                  'Add_a_note_for_your_teammate_min_word_limit',
                  `Add a note for your teammate min words limit`,
                ) + ` ${feedbackConfiguration.minFeedbackWords}`
              : t(
                  'Add_a_note_for_your_teammate',
                  'Add a note for your teammate',
                )
          }
          height={'22vh'}
          onChange={(editorState) =>
            onCommentChange(editorState?.toString() || '')
          }
          value={convertHTMLToDraftJS(comment)}
          showActionButton={false}
          isDataLoading={false}
        />
      ) : null}
    </>
  );
};

export default EvaluationRecommendationEdit;
